import React, { Component } from 'react';
import { arrayOf, string, bool, func, object } from 'prop-types';
import classNames from 'classnames';
import {
    Switch,
    Checkbox,
    FormControlLabel,
    Grid
} from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { createTheme, MuiThemeProvider } from '@material-ui/core';
import { get } from 'lodash';

export const TRAFFIC_CHANNELS = 'traffic_filter';
import styles from './styles.scss';

const theme = createTheme({
    overrides: {
        MuiCheckbox: {
            colorPrimary: {
                '&$checked': {
                    color: '#2196F3'
                }
            },
            root: {
                padding: '12px',
            }
        },
        MuiSwitch: {
            colorPrimary: {
                '&$checked': {
                    color: '#2196F3',
                },
                '&$checked + $track' : {
                    backgroundColor: '#2196F3'
                }
            }
        }
    }
});

class TrafficChannels extends Component {
    static propTypes = {
        trafficChannels: arrayOf(object),
        selected: arrayOf(string),
        title: string,
        description: string,
        overrideDescription: string,
        isOverrideable: bool,
        isInConfig: bool,
        onChange: func,
        legacyTrafficChannelsTitle: string,
        gbqTrafficChannelsTitle: string,
        isGbqEnabled: bool,
        isAdobeEnabled: bool,
        adobeTrafficChannelsTitle: string
    };

    static defaultProps = {
        title: 'Traffic Channels',
        description: 'Select the category to make it available to the campaign. Traffic channels indicate how web traffic was classified.',
        overrideDescription: 'Allow users to override the admin setting and change traffic channels.',
        isInConfig: false,
        legacyTrafficChannelsTitle: 'Legacy Traffic Channels',
        gbqTrafficChannelsTitle: 'GBQ Traffic Channels (GBQ Advertisers Only)',
        adobeTrafficChannelsTitle : 'Adobe Analytics Traffic Channels (Adobe Advertisers Only)'
    };

    handleChange = (event) => {
        const { onChange, selected, isOverrideable } = this.props;
        const id = event.target.value || '';
        let newSelected = [];
        if (selected.indexOf(id) === -1) {
            newSelected = [...selected, id];
        } else {
            newSelected = selected.filter(item => item !== id);
        }
        onChange && onChange({
            setting_name: TRAFFIC_CHANNELS,
            setting_value: {
                selected: newSelected,
                isOverride: isOverrideable
            }
        });
    }

    handleAllowOverride = (e) => {
        const { onChange, selected, isOverrideable } = this.props;        
        
        onChange && onChange({
            setting_name: TRAFFIC_CHANNELS,
            setting_value: {
                selected,
                isOverride: !isOverrideable
            }
        });
    }

    handleTrafficChannelType = (trafficChannels) => {
        let legacyTrafficChannels = [];
        let gbqTrafficChannels = [];
        let adobeTrafficChannels = [];
        trafficChannels && trafficChannels.map(item => {
            const supportingSource = get(item, 'supporting_sources', []);
            if (supportingSource.includes('ua')) {
                legacyTrafficChannels.push(item);
            } else if (supportingSource.length === 1 && supportingSource.includes('big_query')) {
                gbqTrafficChannels.push(item);
            } else if(supportingSource.length === 1 && supportingSource.includes('adobe')) {
                adobeTrafficChannels.push(item);
            }
        })
        return {
            legacyTrafficChannels,
            gbqTrafficChannels,
            adobeTrafficChannels
        }
    }

    drawTrafficChannelListItems = ({trafficChannels, title, isInConfig, isReadOnly, selected, isShowTitle}) => {
        return (
            trafficChannels.length > 0 && <div className={styles.trafficChannelsListContainer}>
                       {isShowTitle && <div className={styles.trafficChannelsTitleOptions}>{title}</div>}
                        <div className={classNames(styles.settingListContainer,
                            { [styles.campaignTabContainer]: !isInConfig },
                            { [styles.configPageContainer]: isInConfig },
                            { [styles.isReadOnly]: isReadOnly })}
                        >

                            <Grid container>
                                {
                                    trafficChannels && trafficChannels.map(filter =>
                                        <Grid item xs={6} lg={6} key={filter.id}>
                                            <FormControlLabel
                                                key={filter.id}
                                                className={styles.trafficChannelsItem}
                                                classes={{
                                                    disabled: styles.readOnlyText,
                                                    label: styles.labelText
                                                }}
                                                disabled={isReadOnly}
                                                control={
                                                    isReadOnly ?
                                                        <FiberManualRecordIcon className={styles.readOnlyIcon} /> :
                                                        <Checkbox
                                                            color="primary"
                                                            checked={selected.indexOf(filter.id) !== -1}
                                                            onChange={this.handleChange}
                                                            value={filter.id}
                                                        // style={{ padding: '12px' }}
                                                        />
                                                }
                                                label={filter.displayName}
                                            />
                                        </Grid>
                                    )
                                }
                            </Grid>
                        </div>
                    </div>
        )
    }

    render() {
        const { 
            trafficChannels,
            selected = [],
            title,
            description,
            overrideDescription,
            isOverrideable,
            isInConfig,
            legacyTrafficChannelsTitle,
            gbqTrafficChannelsTitle,
            isGbqEnabled,
            isAdobeEnabled,
            adobeTrafficChannelsTitle
        } = this.props;
        const isReadOnly = !isInConfig && !isOverrideable;
        const { legacyTrafficChannels, gbqTrafficChannels, adobeTrafficChannels } = this.handleTrafficChannelType(trafficChannels);
        return (
            <MuiThemeProvider theme={theme}>
            <div
              className={classNames({
                [styles.trafficContainerInConfigPage]: isInConfig
              })}
            >
              <div>
                <h2 className={styles.title}>{title}</h2>
                <p
                  className={classNames(styles.description, {
                    [styles.configPageDesc]: isInConfig
                  })}
                >
                  {description}
                </p>
              </div>
              {isInConfig && (
                <div className={styles.switchBox}>
                  <Switch
                    checked={isOverrideable}
                    onChange={this.handleAllowOverride}
                    name="isOverrideable"
                    color="primary"
                  />
                  <span className={styles.switchDescription}>
                    {overrideDescription}
                  </span>
                  </div>
              )}
              {this.drawTrafficChannelListItems({
                trafficChannels: legacyTrafficChannels,
                title: legacyTrafficChannelsTitle,
                isInConfig,
                isReadOnly,
                selected,
                isShowTitle:isGbqEnabled,
              })}
              {isGbqEnabled &&
                this.drawTrafficChannelListItems({
                  trafficChannels: gbqTrafficChannels,
                  title: gbqTrafficChannelsTitle,
                  isInConfig,
                  isReadOnly,
                  selected,
                  isShowTitle:isGbqEnabled, 
                })}
              {isAdobeEnabled &&
                this.drawTrafficChannelListItems({
                  trafficChannels: adobeTrafficChannels,
                  title: adobeTrafficChannelsTitle,
                  isInConfig,
                  isReadOnly,
                  selected,
                  isShowTitle: isAdobeEnabled, 
                })}
            </div>
          </MuiThemeProvider>
        )
    }
}

export default TrafficChannels;
